/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:44:05
 */
import en from 'element-ui/lib/locale/lang/en'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Phân tích báo cáo AI",
        train: "Kế hoạch tập luyện",
        loading: "Đang tải, vui lòng đợi...",
        loadingError1: "Không tải được báo cáo",
        loadingError2: "Xin lỗi vì sự bất tiện này. Vui lòng thử lại sau.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Đăng ký/Đăng nhập',
        registerAndLogin: 'Đăng nhập/Đăng ký',
        userLogin: 'Đăng nhập',
        title: 'Tài khoản điện thoại và email là độc lập. Vui lòng kiểm tra loại tài khoản của bạn.',
        mobileLogin: 'Số điện thoại',
        emailLogin: 'Email',
        email: 'E-mail',
        loginBtn: 'Đăng nhập',
        autoLogin: 'Tự động đăng nhập lần sau',
        retransmission: 'Gửi lại sau {item} giây',
        formList: [
            {
                label: 'Vui lòng nhập số điện thoại',
                placeholder: 'Lấy mã xác minh',
            },
            {
                label: 'Mã xác minh',
                placeholder: '',
            },
            {
                label: 'Vui lòng nhập địa chỉ email',
            },
        ],
        btn: {
            submit: 'Tạo tài khoản mới',
            title: 'Thông tin chính xác rất quan trọng. Vui lòng điền đầy đủ và chính xác',
        },
        rule: {
            phone: {
                requiredMsg: 'Định dạng số điện thoại không hợp lệ',
                patternMsg: 'Số điện thoại chưa được đăng ký. Vui lòng tạo tài khoản mới.',
            },
            authCode: {
                requiredMsg: 'Mã xác minh không đúng. Vui lòng thử lại.',
            },
            email: {
                requiredMsg: 'Định dạng địa chỉ email không hợp lệ',
                patternMsg: 'Email chưa được đăng ký. Vui lòng tạo tài khoản mới.',
            },
        },
        codeSuccess: 'Mã xác minh đã được gửi. Vui lòng kiểm tra.',
        success: 'Gửi thành công',
        error: 'Gửi thất bại',
        loginSuccess: 'Đăng nhập thành công',
        account: {
            accountTitle: 'Đăng nhập',
            registerTitle: 'Đăng ký',
            resetTitle: 'Đặt mật khẩu',
            password: 'Mật khẩu',
            placeholder: 'Vui lòng nhập mật khẩu',
            codeLogin: 'Đăng nhập bằng mã xác minh',
            accountLogin: 'Đăng nhập bằng mật khẩu',
            forgotPassword: 'Quên mật khẩu?',
            registerTips:[
                'Chưa có tài khoản?', 
                'Đăng ký', 
                'Tài khoản đã tồn tại',
                'Đăng ký ngay',
            ],
            checkRule: [
                '8-20 ký tự',
                'Ít nhất một chữ viết hoa',
                'Ít nhất một chữ thường',
                'Ít nhất một chữ số', 
                'Mật khẩu không khớp'
            ],
            errorTips: [
                'Sai mật khẩu', 
                'Đăng nhập không thành công', 
                'Tài khoản không tồn tại'
            ],
            reset:[
                'Đặt lại mật khẩu', 
                "Tiếp theo",
                'Mật khẩu mới không được trùng với mật khẩu trước', 
                'Bỏ qua',
                'Đặt mật khẩu thành công'
            ],
            setPasswordTips:'Mật khẩu phải dài từ 8-20 ký tự, bao gồm chữ hoa, chữ thường và số.',
            confirmPassword: "Xác nhận mật khẩu",
        },
        switchButton: 'Đăng nhập bằng mật khẩu',
        switchButton1: 'Đăng nhập bằng mã xác minh',
        loginTips: 'Tài khoản chưa đăng ký sẽ được tự động tạo khi đăng nhập thành công',
        otherLogin: 'Các phương thức đăng nhập khác',
        newEmailLogin: 'Đăng nhập bằng email',
        newPhoneLogin: 'Đăng nhập bằng số điện thoại',
        bindLineTips:'Hoặc',
        bindEmail: 'Đăng nhập bằng email đã liên kết',
        bindPhone: 'Đăng nhập bằng số điện thoại đã liên kết',
        bindAndContinue: "Liên kết và tiếp tục",
        bind: "Liên kết",
        bindEmailTitle: 'Liên kết email',
        bindEmailTips1: "Không tìm thấy thông tin email {item}",
        bindEmailTips2: "Vui lòng liên kết email để tiếp tục",
        bindEmailTips3: "Tài khoản chưa liên kết email. Sau khi liên kết có thể đăng nhập và lấy lại mật khẩu.",
        boundTitle: 'Bạn đã từng đăng ký chưa?',
        boundCenterTitle1:'Nếu bạn là người dùng mới',
        boundCenterTips1:'Có thể trực tiếp tạo tài khoản và sử dụng',
        boundCenterTitle2:'Nếu bạn đã có tài khoản',
        boundCenterTips2:'Có thể liên kết tài khoản cũ để đồng bộ dữ liệu',
        boundCenterTips3:'Vui lòng liên kết một tài khoản đã đăng ký',
        boundCenterTips4:'Đề xuất',
        boundCenterTips5:'Liên kết tài khoản {item} vào tài khoản cũ',
        boundCenterTips6:'Sau khi liên kết, dữ liệu và báo cáo sẽ đồng bộ',
        boundButton1: 'Tạo tài khoản bằng {item}',
        boundButton2: 'Liên kết tài khoản đã có',
        phoneCode:"Đăng nhập mã SMS",
        phonePassword:"Đăng nhập bằng số điện thoại và mật khẩu",
        emailCode:"Đăng nhập mã email",
        emailPassword:"Đăng nhập bằng email và mật khẩu",
        accountDoesNotExist:"Tài khoản này chưa được đăng ký. Vui lòng hoàn tất đăng ký bằng mã xác nhận email hoặc qua {item}.",
        toRegister:"Đăng ký ngay",
        bindNow: "Liên kết ngay",
        bindError:[
            'Liên kết thất bại',
            'Hủy liên kết thành công',
            'Hủy liên kết thất bại',
            'Ủy quyền thất bại',
            'Ủy quyền thất bại, không thể lấy thông tin tài khoản',
            'Liên kết thành công',
            'Tài khoản không tồn tại. Vui lòng liên kết một tài khoản đã đăng ký.',
            'Liên kết thất bại. Tài khoản này đã được liên kết với tài khoản {item}. [{nickname}]',
            'Đã được ủy quyền và đăng ký làm tài khoản. Không hỗ trợ hủy liên kết.',
            'Tài khoản không tồn tại. Vui lòng sử dụng mã xác minh để đăng nhập và đăng ký.',
        ],
        accountSecurity: {
            faceBook:'Tài khoản Facebook',
            google: 'Tài khoản Google',
            isBind: 'Chưa liên kết',
            dialogTitle: 'Xác nhận hủy liên kết?',
            dialogCenter: 'Sau khi hủy liên kết {item}, bạn sẽ không thể sử dụng nó để đăng nhập vào tài khoản này nữa.',
            bindFailure:'Liên kết thất bại',
            bindFailureTips: 'Tài khoản {item} của bạn đã được liên kết với tài khoản bên dưới. Nếu muốn chuyển sang tài khoản hiện tại, vui lòng đăng nhập vào tài khoản bên dưới để hủy liên kết trước.',
            returnButton:'Xác nhận và quay lại'
        },
        bindEmailError: [
            "Email đã tồn tại, vui lòng sử dụng địa chỉ email khác.",
        ],

    },
    // 注册页面
    register: {
        mobileRegister: 'Đăng ký bằng số điện thoại',
        emailRegister: 'Đăng ký bằng email',
        enroll: 'Số điện thoại đã được đăng ký',
        enrollEmail: 'Email này đã được đăng ký',
        search: 'Tìm kiếm',
        title: 'Tài khoản điện thoại và email là độc lập. Vui lòng kiểm tra loại tài khoản của bạn.',
        needRead: {
            agree: 'Tôi đã đọc và đồng ý với',
            privacy: 'Chính sách bảo mật người dùng',
        },
        register: 'Đăng ký',
        check: 'Chọn "Chính sách bảo mật người dùng"',
        newUser: 'Đăng ký người dùng mới',
        form: {
            labelList: ['Tên', '* Giới tính', '* Chiều cao', '* Tuổi'],
        },
        placeholder: ['Vui lòng nhập họ tên', 'Vui lòng nhập chiều cao của bạn', 'Vui lòng nhập tuổi của bạn'],
        unit: ['Hệ mét', 'Hệ Anh', 'Tuổi'],
        sexOptions: {
            male: 'Nam',
            female: 'Nữ',
        },
        btn: 'Xác nhận',
        rules: {
            metricheight: ['Phạm vi chiều cao cho phép là 2ft3in–6ft7in. Vui lòng nhập lại.'],
            heightMsg: ['Phạm vi chiều cao cho phép là 70–200 cm. Vui lòng nhập lại.'],
            ageMsg: ['Phạm vi tuổi cho phép là 10–99 tuổi. Vui lòng nhập lại.'],
            agePointMsg: ['Dữ liệu không hợp lệ: tuổi phải là số nguyên. Vui lòng nhập tuổi hợp lệ.'],
        },
        success: 'Đăng ký thành công',
        userMessage: 'Vui lòng nhập tên người dùng',
        verify: 'Vui lòng nhập mã xác minh 4 chữ số',
        errorMsg: 'Định dạng chiều cao phải là số nguyên. Vui lòng nhập lại.',
        abnormalMsg: 'Lỗi đăng ký',
    },
    // 模型合成
    model: {
        loading: 'Đang tạo mô hình, vui lòng đợi',
        modelLoading: 'Đang tải mô hình...',
        tabPane: [
            {
                title: 'Công nghệ cảm biến chiều sâu',
                msg: 'Thu thập chính xác các chi tiết cơ thể thông qua quét 3D để đảm bảo độ chính xác ở mức milimet trong đo chu vi, giúp thay đổi hình thể sau tập luyện hiển thị rõ ràng.',
            },
            {
                title: 'Thuật toán thành phần cơ thể BDA',
                msg: 'Visbody sử dụng hệ thống BDA hiện đại nhất để xác định thành phần cơ thể, cung cấp đánh giá dựa trên thể tích để ước tính chính xác hơn các rủi ro sức khỏe do béo phì.',
            },
            {
                title: 'Các yếu tố có thể gây ra sai số',
                msg: 'Quần áo rộng hoặc vật lạ trên người có thể gây ra sai số. Để có kết quả chính xác nhất, vui lòng mặc quần áo bó sát hoặc ít quần áo bên ngoài hơn.',
            },
            {
                title: 'Truy cập báo cáo',
                msg: 'Chúng tôi khuyên bạn nên đánh dấu trang để truy cập sau này. Bạn cũng có thể gửi báo cáo này đến email của mình để lưu.',
            },
        ],
        collect: ['Vui lòng đánh dấu trang này.', 'Để dễ dàng truy cập báo cáo sau này.'],
        know: 'Đã hiểu',
        reminder: [
            'Lưu ý',
            'Mô hình 3D của bạn đã được tạo. Hãy thử vuốt để xoay.',
            'Báo cáo của bạn đã sẵn sàng. Nhấp vào nút "Xem báo cáo" để xem.',
            'Đánh giá tư thế thất bại. Vui lòng xem báo cáo thành phần cơ thể.',
            'Đo thành phần cơ thể thất bại. Vui lòng xem báo cáo phân tích tư thế.',
            'Đo lường thất bại. Vui lòng thử lại trên thiết bị.~',
            'Đo thành phần cơ thể thất bại. Vui lòng thử lại trên thiết bị.~',
            'Đánh giá tư thế thất bại. Vui lòng thử lại trên thiết bị.~',
        ],
        btn: {
            viewReport: 'Xem báo cáo',
            bodyReport: 'Xem báo cáo thành phần cơ thể',
            postureReport: 'Xem báo cáo tư thế',
            lastReport: 'Xem báo cáo trước',
            loading: 'Đang tải...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Tải xuống báo cáo',
            send: 'Gửi báo cáo',
            report: 'Báo cáo',
        },
        reportSuccess: 'Báo cáo đã được tạo thành công',
        tabPane: {
            labelList: ['Thời gian đo', 'Hạng mục đo', 'Thành phần cơ thể', 'Đánh giá tư thế', 'Chức năng vai'],
        },
        sendEmail: 'Gửi đến email:',
        requiredMsg: 'Vui lòng nhập địa chỉ email của bạn',
        patternMsg: 'Vui lòng nhập một địa chỉ email hợp lệ',
        send: 'Gửi',
        download: 'Tải xuống báo cáo',
        sendReport: 'Gửi báo cáo',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Cập nhật giới tính thành công',
            height: 'Cập nhật chiều cao thành công',
            age: 'Cập nhật tuổi thành công',
        },
        logOut: 'Đăng xuất',
        personal: 'Trang cá nhân',
        cut: 'Chuyển đổi đơn vị/ngôn ngữ',
        changeSort: 'Chuyển đổi báo cáo sản phẩm',
        setPassword: 'Đặt/Thay đổi mật khẩu',
        accountSecurity: 'Tài khoản và bảo mật',
        describe: '* Sau khi chuyển đổi kiểu sản phẩm, tất cả các báo cáo đo lường liên quan sẽ được hiển thị.',
        describeBtn: 'Sau khi chuyển đổi kiểu sản phẩm, bạn sẽ được chuyển hướng đến báo cáo mới nhất.',
        descReport: 'Chuyển đổi báo cáo sản phẩm thành công',
        unit: ['Hệ mét (kg, cm)', 'Hệ Anh (ft, in, lb)'],
        read: {
            reading: 'Đã xem',
            privacy: 'Chính sách bảo mật người dùng',
        },
        setting: 'Cài đặt',
        form: {
            labelList: ['Số điện thoại', 'Đơn vị', 'Ngôn ngữ', 'Biệt danh', 'Giới tính', 'Chiều cao', 'Tuổi'],
        },
        placeholder: ['Chỉnh sửa biệt danh', 'Chỉnh sửa giới tính', 'Chỉnh sửa chiều cao', 'Chỉnh sửa tuổi'],
        btn: {
            cancelBtn: 'Hủy',
            accomplishBtn: 'Xong',
            confirmBtn: 'Xác nhận',
        },
        dialog: [
            'Giới tính là một yếu tố quan trọng trong phân tích thành phần cơ thể. Việc sửa đổi có thể ảnh hưởng đến việc so sánh với dữ liệu trước đây. Xác nhận thay đổi?',
            'Chiều cao là một yếu tố quan trọng trong phân tích thành phần cơ thể. Việc sửa đổi có thể ảnh hưởng đến việc so sánh với dữ liệu trước đây. Xác nhận thay đổi?',
            'Tuổi là một yếu tố quan trọng trong phân tích thành phần cơ thể. Việc sửa đổi có thể ảnh hưởng đến việc so sánh với dữ liệu trước đây. Xác nhận thay đổi?',
        ],
        rules: {
            metricheight: ['Vui lòng nhập chiều cao trong khoảng (2ft3in–6ft7in)'],
            heightMsg: ['Vui lòng nhập chiều cao trong khoảng (70–200cm)'],
            ageMsg: ['Vui lòng nhập tuổi trong khoảng (10–99 tuổi)', 'Dữ liệu không hợp lệ: tuổi phải là số nguyên. Vui lòng nhập tuổi hợp lệ.'],
        },
        heightMsg: 'Vui lòng chọn lại chiều cao',
        ageMsg: 'Vui lòng chọn lại tuổi',
        ModelBinding: 'Dường như đã có người khác quét mã này. Vui lòng đo lại.',
        ReportEmpty: {
            title: 'Bạn chưa có báo cáo phù hợp nào',
            desc: 'Hãy tìm Máy quét cơ thể 3D Visbody và thực hiện một phép đo!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Dường như đã có người khác quét mã này. Vui lòng đo lại.',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Bạn chưa có báo cáo phù hợp nào',
        desc: 'Hãy tìm Máy quét 3D Visbody và thực hiện một phép đo!',
        descS30: 'Hãy tìm Máy quét 3D Visbody-S30 và thực hiện một phép đo!',
        descM30: 'Hãy tìm Máy quét 3D Visbody-M30 và thực hiện một phép đo!',
    },
    // 用户信息
    userInfo: {
        height: 'Chiều cao:',
        age: 'Tuổi:',
        unit: 'Tuổi',
        weight: 'Cân nặng',
    },
    // 体成分
    mass: {
        title: 'Tổng quan đánh giá thành phần cơ thể',
        titles: 'Thành phần cơ thể',
        springFrame: '',
        massFrame: 'Không có dữ liệu đo nào cho hôm nay',
        contrast: 'Chọn một báo cáo để so sánh',
        contrastReport: 'Chọn một báo cáo so sánh',
        noRecord: 'Không có dữ liệu',
        score: 'Điểm',
        status: 'Tình trạng thành phần cơ thể hiện tại của bạn',
        WT: 'Cân nặng',
        PBF: 'Tỷ lệ mỡ cơ thể',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Giá trị đo',
            standardRange: 'Khoảng tiêu chuẩn',
            comparedWithLastLime: 'So với lần trước',
            comparedNet: 'So với lần trước',
            current: 'Điểm đo lần này',
            WT: 'Cân nặng',
            FFM: 'Khối lượng nạc',
            BFM: 'Khối lượng mỡ',
            LM: 'Khối lượng cơ',
            TBW: 'Tổng lượng nước',
            SM: 'Cơ xương',
            PROTEIN: 'Chất đạm',
            TM: 'Khoáng chất',
            BMR: 'Trao đổi chất cơ bản',
            WHR: 'Tỷ lệ eo-hông',
            BMI: 'BMI',
            PBF: 'Tỷ lệ mỡ cơ thể',
            VFG: 'Cấp độ mỡ nội tạng',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        // 定义解读
        explain: [
            {
                title: 'Cân nặng',
                msg: 'Cân nặng là tổng của lượng nước, protein, Khoáng chất và mỡ trong cơ thể.',
            },
            {
                title: 'Khối lượng nạc',
                msg: 'Khối lượng cơ thể không mỡ = cân nặng trừ mỡ.',
            },
            {
                title: 'Khối lượng mỡ',
                msg: 'Mỡ cơ thể là tổng mỡ dưới da, mỡ nội tạng và mỡ giữa các cơ.',
            },
            {
                title: 'Khối lượng cơ',
                msg: 'Khối lượng cơ là nhóm mô nạc của cơ thể, bao gồm cơ xương, cơ trơn và cơ tim.',
            },
            {
                title: 'Tổng lượng nước',
                msg: 'Nước chiếm 50%–70% trọng lượng cơ thể, chủ yếu ở tế bào và dịch cơ thể, phần lớn trong tế bào cơ.',
            },
            {
                title: 'Cơ xương',
                msg: 'Cơ xương, còn gọi là cơ vân, là cơ bám vào xương. Đây là khối lượng được tính toán.',
            },
            {
                title: 'Chất đạm',
                msg: 'Protein là chất rắn chứa nitơ, có trong tất cả tế bào và là thành phần chính của khối lượng cơ.',
            },
            {
                title: 'Khoáng chất',
                msg: 'Khoáng chất chiếm khoảng 5% trọng lượng cơ thể.',
            },
            {
                title: 'Trao đổi chất cơ bản',
                msg: 'BMR là tổng năng lượng cơ thể tiêu thụ trong một ngày khi tỉnh táo và nghỉ ngơi, không bị ảnh hưởng bởi vận động, thức ăn, căng thẳng thần kinh hoặc thay đổi nhiệt độ bên ngoài.',
            },
            {
                title: 'Tỷ lệ eo-hông',
                msg: 'Tỷ lệ eo-hông (WHR) là chỉ số quan trọng để đánh giá béo phì trung tâm.',
            },
            {
                title: 'BMI',
                msg: 'BMI được sử dụng để đánh giá mức độ mỡ cơ thể và là một tiêu chuẩn quốc tế phổ biến.',
            },
            {
                title: 'Tỷ lệ mỡ cơ thể',
                msg: 'Tỷ lệ mỡ cơ thể là phần trăm mỡ trên tổng trọng lượng cơ thể.',
            },
            {
                title: 'Cấp độ mỡ nội tạng',
                msg: 'Cấp độ mỡ nội tạng là chỉ số quan trọng để đánh giá béo phì tiềm ẩn.',
            },
            {
                title: 'Dịch nội bào',
                msg: 'Dịch nội bào: là dịch bên trong tế bào và là thành phần cơ bản của nguyên sinh chất.',
            },
            {
                title: 'Dịch ngoại bào',
                msg: 'Dịch ngoại bào: là dịch bên ngoài tế bào, bao gồm huyết tương và dịch kẽ.',
            },
            {
                title: 'Tuổi trao đổi chất',
                msg: 'Tuổi trao đổi chất phản ánh hiệu suất của cơ thể và các chức năng trao đổi chất liên quan đến sức khỏe.',
            },
            {
                title: 'Tỷ lệ ECW/TBW',
                msg: 'Tỷ lệ ECW/TBW là tỷ lệ nước ngoại bào (ECW) trong tổng lượng nước của cơ thể (TBW). Đây là một chỉ số quan trọng để đánh giá tình trạng cân bằng dịch của cơ thể.',
            },
        ],
        // 节段
        segment: {
            fat: 'Mỡ theo vùng cơ thể',
            muscle: 'Cơ theo vùng cơ thể',
            right: 'Phải',
            left: 'Trái',
            standard: 'Tiêu chuẩn',
            lowStandard: 'Dưới tiêu chuẩn',
            superStandard: 'Vượt tiêu chuẩn',
            peel: '(Trừ bì)',
        },
    },
    // 体态
    shape: {
        title: 'Tổng quan đánh giá tư thế',
        titles: 'Đánh giá tư thế',
        status: 'Tình trạng tư thế hiện tại của bạn',
        suggest: 'Gợi ý',
        possibility: ', xuất hiện',
        models: {
            front: 'Mặt trước',
            left: 'Nhìn từ bên trái',
            right: 'Nhìn từ bên phải',
            top: 'Mặt sau',
            low: 'Dưới trung bình',
            high: 'Trên trung bình',
            normal: 'Bình thường',
        },
        item: {
            deviate: 'Giá trị đo',
            result: 'Mô tả',
            normal: 'Bình thường',
            abnormal: 'Bất thường',
            keAbnormal: 'Bất thường tiềm ẩn',
            head: 'Tư thế đầu hướng về phía trước',
            headSlant: 'Tư thế đầu nghiêng sang bên',
            roundShoulderLeft: 'Tư thế vai tròn (bên trái)',
            roundShoulderRight: 'Tư thế vai tròn (bên phải)',
            highLowShoudler: 'Vai không cân xứng',
            pelvis: 'Dịch chuyển khung chậu ra trước/sau',
            leftKneeCheck: 'Đánh giá đầu gối trái',
            rightKneeCheck: 'Đánh giá đầu gối phải',
            leg: 'Dáng chân',
            leftLeg: 'Chân trái:',
            rightLeg: 'Chân phải:',
        },
        // 定义解读
        explain: [
            {
                title: 'Tư thế đầu hướng về phía trước',
                msg: 'Góc giữa đường từ điểm tai đến tâm cổ bên trái và đường giữa bên',
            },
            {
                title: 'Tư thế đầu nghiêng sang bên',
                msg: 'Góc giữa đường từ điểm giữa đầu đến tâm cổ và đường giữa phía trước',
            },
            {
                title: 'Tư thế vai tròn (bên trái)',
                msg: 'Góc giữa điểm cao nhất ở lưng trái và đường tiếp tuyến vai',
            },
            {
                title: 'Tư thế vai tròn (bên phải)',
                msg: 'Góc giữa điểm cao nhất ở lưng phải và đường tiếp tuyến vai',
            },
            {
                title: 'Vai không cân xứng',
                msg: 'Khoảng cách dọc giữa mỏm cùng vai trái và phải',
            },
            {
                title: 'Dịch chuyển khung chậu ra trước/sau',
                msg: 'Góc giữa các điểm tâm cổ, hông và mắt cá chân khi nhìn từ bên trái',
            },
            {
                title: 'Đánh giá đầu gối trái',
                msg: 'Góc giữa hông, đầu gối và mắt cá chân khi nhìn từ bên trái',
            },
            {
                title: 'Đánh giá đầu gối phải',
                msg: 'Góc giữa hông, đầu gối và mắt cá chân khi nhìn từ bên phải',
            },
            {
                title: 'Dáng chân',
                msg: 'Góc được tạo bởi hông, đầu gối và mắt cá chân khi nhìn từ phía trước cho cả hai chân',
            },
            {
                title: 'Khung chậu nghiêng trước/sau',
                msg: 'Góc giữa đường thẳng đứng và mặt phẳng được tạo bởi gai chậu trước trên bên trái và phải và khớp mu.'
            },
            {
                title: 'Chênh lệch chiều dài chân',
                msg: 'Chênh lệch chiều cao từ mặt đất giữa các điểm thấp nhất của nếp gấp mông trái và phải.'
            }
        ],
        exception: [
            {
                title: 'Lệch trái',
                abnormal: '',
            },
            {
                title: 'Lệch phải',
                abnormal: '',
            },
            {
                title: 'Bên trái cao hơn',
                abnormal: '',
            },
            {
                title: 'Bên phải cao hơn',
                abnormal: '',
            },
            {
                title: 'Khung chậu dịch chuyển về phía sau',
                abnormal: '',
            },
            {
                title: 'Khung chậu dịch chuyển về phía trước',
                abnormal: '',
            },
            {
                title: 'Duỗi quá mức đầu gối trái',
                abnormal: '',
            },
            {
                title: 'Gấp đầu gối trái',
                abnormal: '',
            },
            {
                title: 'Duỗi quá mức đầu gối phải',
                abnormal: '',
            },
            {
                title: 'Gấp đầu gối phải',
                abnormal: '',
            },
            {
                title: 'Chân chữ K',
                abnormal: '',
            },
            {
                title: 'Chân chữ D',
                abnormal: '',
            },
            {
                title: 'Chân chữ X',
                abnormal: '',
            },
            {
                title: 'Chân chữ O',
                abnormal: '',
            },
            {
                title: 'Nghiêng khung chậu về phía trước',
                abnormal: ''
            },
            {
                title: 'Nghiêng khung chậu về phía sau',
                abnormal: ''
            },
            {
                title: 'Bất thường chiều dài chân trái',
                abnormal: ''
            },
            {
                title: 'Bất thường chiều dài chân phải',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Khoảng cách dọc giữa tai và đường trọng lực của cơ thể',
            },
            {
                msg: 'Góc giữa đường nối hai tai và đường ngang',
            },
            {
                msg: 'Khoảng cách dọc giữa mỏm cùng vai trái và đường trọng lực',
            },
            {
                msg: 'Khoảng cách dọc giữa mỏm cùng vai phải và đường trọng lực',
            },
            {
                msg: 'Chênh lệch giữa đường nối gốc cổ và mỏm cùng vai (trái & phải)',
            },
            {
                msg: 'Khoảng cách dọc giữa khớp háng và đường trọng lực của cơ thể',
            },
            {
                msg: 'Góc giữa mắt cá chân, điểm cách dưới đầu gối trái 1cm và hông (mặt phẳng đứng dọc)',
            },
            {
                msg: 'Góc giữa mắt cá chân, điểm dưới đầu gối phải 1cm và hông (mặt phẳng dọc)',
            },
            {
                msg: 'Góc giữa hông, đầu gối và mắt cá chân trái/phải (mặt phẳng trán)',
            },
        ],
        item: {
            pelvis: 'Khung chậu dịch chuyển về phía trước',
        },
    },
    // 围度信息
    girth: {
        title: 'Chu vi cơ thể',
        present: '(Lần này)',
        noHistory: 'Không có dữ liệu khả dụng.',
        tpl: [
            {
                title: 'Chu vi cổ',
                key: 'neckGirth',
            },
            {
                title: 'Chu vi bắp tay trái',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Chu vi bắp tay phải',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Chu vi ngực',
                key: 'bustGirth',
            },
            {
                title: 'Chu vi eo trên',
                key: 'waistGirth',
            },
            {
                title: 'Chu vi eo giữa',
                key: 'midWaistGirth',
            },
            {
                title: 'Chu vi hông',
                key: 'hipGirth',
            },
            {
                title: 'Chu vi đùi trái',
                key: 'leftThighGirth',
            },
            {
                title: 'Chu vi giữa đùi trái',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Chu vi nhỏ nhất của đùi trái',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Chu vi đùi phải',
                key: 'rightThighGirth',
            },
            {
                title: 'Chu vi giữa đùi phải',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Chu vi nhỏ nhất của đùi phải',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Chu vi bắp chân trái',
                key: 'leftCalfGirth',
            },
            {
                title: 'Chu vi bắp chân phải',
                key: 'rightCalfGirth',
            },
            {
                title: 'Chu vi eo thấp',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Chức năng vai',
        model: {
            val: 'Giá trị đo',
            scope: 'Vị trí hoạt động tối đa',
            diff: 'So với lần trước',
        },
        normal: 'Đánh giá không phát hiện bất thường đáng kể.',
        normalAll: 'Chức năng vai hiện chưa phát hiện bất thường rõ rệt',
        conclusion: 'Kết luận',
        analyse: 'Phân tích: ',
        suggest: 'Khuyến nghị:',
        cause: 'Vui lòng tham khảo ý kiến chuyên gia để được đánh giá thêm.',
    },
    reportTips: {
        title: "Bạn có chắc chắn muốn xóa báo cáo này không? Sau khi xóa, báo cáo sẽ không thể khôi phục.",
        confirm: "Xóa",
        success: "Báo cáo đã bị xóa",
        partial: "Báo cáo đã bị xóa, nhưng đồng bộ một phần dữ liệu đã thất bại. Vui lòng liên hệ với quản trị viên.",
        failed: "Xóa không thành công, vui lòng thử lại sau",
        btnMsg: 'OK',
        alaryTips: 'Báo cáo này đã bị quản trị viên xóa. Bạn sẽ được chuyển hướng đến báo cáo tiếp theo.',
    },
    saveQr: {
        title: 'Báo cáo thành phần cơ thể 3D Visbody',
        btnMsg: 'Nhấn và giữ hình ảnh để lưu vào điện thoại',
        tips: 'Nếu không thể lưu, vui lòng bật quyền trong [Cài đặt]',
    },
    share: {
        title: 'Vui lòng sao chép liên kết bên dưới để chia sẻ',
        btnMsg: 'Sao chép',
    },
    'bodyPrediction': {
        'body-title': 'Dự đoán hình thể',
        'body-yu-ce-status': 'Dự đoán dựa trên tình trạng hiện tại của bạn',
        'body-setting': 'Cài đặt dự đoán hình thể',
        'body-li-xiang': 'Giá trị lý tưởng: ',
        'body-ti-zhong': 'Cân nặng',
        'body-ti-zhi-lv': 'Tỷ lệ mỡ cơ thể',
        'body-ji-rou': 'Khối lượng cơ',
        'yu-che-pre': 'Trước khi dự đoán',
        'yu-che-after': 'Sau khi dự đoán',
        'zan-model-no': 'Chưa có mô hình',
        'ti-xing-error': 'Ghép kết quả dự đoán hình thể thất bại',
        'ti-xing-worker-error': 'Có thể do lỗi mạng, vui lòng kiểm tra kết nối',
        'ti-xing-adjust': 'Mức điều chỉnh',
        'ji-rou-title': 'Khối lượng cơ',
        'ti-zi-fang': 'Khối lượng mỡ',
        'dang-pre-zhi': 'Giá trị hiện tại: ',
        'nen-zhang': 'Cấp độ mỡ nội tạng',
        'nen-zhang-title': 'Giải thích diện tích mỡ nội tạng',
        'nen-zhang-title1':
            'Mỡ nội tạng là mỡ nằm giữa các cơ quan nội tạng, dễ dẫn đến béo bụng; diện tích mỡ nội tạng thể hiện diện tích tiết diện ngang của mỡ nội tạng.',
    },
    ...en,
    ...agrEn,
    wifi: {
        'title': 'Cài đặt Wi-Fi',
        'tips': 'Vui lòng nhập mật khẩu cho mạng Wi-Fi sau',
        'password': 'Mật khẩu Wi-Fi',
        'password-placeholder': 'Vui lòng nhập mật khẩu Wi-Fi',
        'password-tips': 'Mật khẩu phân biệt chữ hoa/thường, vui lòng nhập chính xác',
        'button': 'Tạo mã QR',
        'h5-title': 'Cấu hình thông tin Wi-Fi',
        'wifi-name': 'Tên Wi-Fi:',
        'wifi-password': 'Mật khẩu Wi-Fi:',
        'wifi-qr-tips1':
            '* Sau khi xác nhận tên và mật khẩu Wi-Fi đúng, hãy đưa mã QR vào camera phía dưới màn hình thiết bị để quét.',
        'wifi-qr-tips2': 'Vui lòng căn chỉnh mã QR Wi-Fi với camera phía dưới màn hình để quét.',
        'wifi-qr-button': 'Quay lại',
    },
    "waist": {
    "title": "Đánh giá vòng eo và bụng",
    "hou": "Sau",
    "qian": "Trước"
  },
  "yao_wei_1": "Vòng eo",
  "yao_bu_fen_shu": "Điểm vòng eo",
  "waist_fen": "Điểm",
  "yao_wei": "Chu vi vòng eo",
  "yao_wei_jian_ti_ji": "Thể tích giữa các chu vi eo",
  "yao_tun_bi": "Tỷ lệ eo-hông",
  "lun_kuo_fen_xi": "Phân tích đường viền",
  "bei_bu": "Vùng lưng",
  "tunbu": "Vùng mông",
  "bei_bu_ti_ji": "Thể tích lưng",
  "zheng_chang_fan_wei": "Khoảng bình thường:",
  "shang_ci": "Trước",
  "ben_ci": "Lần này",
  "gupen": {
    "zheng_chang": "Bình thường",
    "qian_qin_yan_chang": "Nghiêng trước bất thường",
    "qian_qin_yi": "Nguy cơ nghiêng trước",
    "hou_qin_yi": "Nguy cơ nghiêng sau",
    "hou_qin_yan_chang": "Nghiêng sau bất thường",
    "zuo_chang_yan_chang": "Chân trái dài hơn bất thường (chênh lệch chiều dài chân)",
    "zuo_chang_yi": "Nguy cơ chênh lệch: chân trái dài hơn",
    "you_chang_yi": "Nguy cơ chênh lệch: chân phải dài hơn",
    "you_chang_yan_chang": "Chân phải dài hơn bất thường (chênh lệch chiều dài chân)"
  },
  "gao_yao_xian": "Chu vi eo trên",
  "gao_yao_zhong_xian": "Đường giữa eo trên",
  "gao_yao_xia_xian": "Đường dưới eo trên",
  "xiao_yao_shang_xian": "Đường trên eo dưới",
  "xiao_yao_zhong_xian": "Đường giữa eo dưới",
  "xiao_yao_xian": "Chu vi eo thấp",
  "qv_jian1": "Phần trên cao của eo",
  "qv_jian2": "Phần dưới cao của eo",
  "qv_jian_zhong": "Phần eo giữa",
  "qv_jian3": "Phần trên thấp của eo",
  "qv_jian4": "Phần dưới thấp của eo",
  "celiang.failed": "Đo không thành công. Vui lòng mặc quần áo bó sát và giữ yên trong khi đo.",
    "jie-gou-yi-chang-ping-gu": "Đánh giá bất thường cấu trúc",
  "teng-tong-feng-xian-ping-gu": "Đánh giá rủi ro đau",
  "zheng-chang": "Bình thường",
  "qing-du-yi-chang": "Bất thường nhẹ",
  "zhong-du2-yi-chang": "Bất thường trung bình",
  "zhong-du-yi-chang": "Bất thường nặng",
  "pen-gu-zhuan-xiang-feng-xian-ping-gu": "Đánh giá rủi ro kh đặc biệt khớp xương chậu",
  "qian-qing": "Nghiêng trước",
  "hou-qing": "Nghiêng sau",
  "xuan-zhuan": "Xoay",
  "pen-gu-qian-qing-feng-xian-fen-shu": "Điểm rủi ro nghiêng khung chậu về phía trước",
  "pen-gu-hou-qing-feng-xian-fen-shu": "Điểm rủi ro nghiêng khung chậu về phía sau",
  "pen-gu-xuan-zhuan-feng-xian-fen-shu": "Điểm rủi ro xoay khung chậu",
  "fen": "điểm",
  "gao-feng-xian": "Nguy cơ cao",
  "ji-rou-ping-gu-jie-guo": "Kết quả đánh giá cơ bắp",
  "qian-qing-feng-xian-gao": "Nguy cơ nghiêng trước cao",
  "hou-qing-feng-xian-gao": "Nguy cơ nghiêng sau cao",
  "xuan-zhuan-feng-xian-gao": "Nguy cơ xoay cao",
  "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo":
      "Cơ chậu hông/cơ duỗi sống phần dưới căng, cơ ngang bụng yếu",
  "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo":
      "Nhóm cơ sau đùi, cơ mông và cơ duỗi sống căng; cơ chậu hông yếu",
  "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng":
      "Yếu cơ mông giữa một bên / mất cân bằng cơ vuông thắt lưng",
  "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Đánh giá cơ liên quan khớp xương chậu bình thường, vui lòng duy trì thói quen sống tốt.",
  "yi-shang-xiang-mu-jun-zheng-chang": "Tất cả các hạng mục trên đều bình thường",
  "ji-zhu-jie-gou-yi-chang-ping-gu": "Đánh giá bất thường cấu trúc cột sống",
  "zheng-ti-ping-fen": "Điểm tổng thể",
  "jing-zhui": "Đốt sống cổ",
  "xiong-zhui": "Đốt sống ngực",
  "yao-zhui": "Đốt sống thắt lưng",
  "jing-zhui-jie-gou-yi-chang-ping-fen": "Điểm bất thường cấu trúc cột sống cổ",
  "xiong-zhui-jie-gou-yi-chang-ping-fen": "Điểm bất thường cấu trúc cột sống ngực",
  "yao-zhui-jie-gou-yi-chang-ping-fen": "Điểm bất thường cấu trúc cột sống thắt lưng",
  "jing-zhui-ji-rou-ping-gu": "Đánh giá cơ cột sống cổ",
  "xiong-zhui-ji-rou-ping-gu": "Đánh giá cơ cột sống ngực",
  "yao-zhui-ji-rou-ping-gu": "Đánh giá cơ cột sống thắt lưng",
  "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "Sắp xếp tổng thể cột sống nhìn chung bình thường",
  "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang":
      "Tư thế đầu và sắp xếp cột sống cổ nhìn chung bình thường",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Đầu nhô/nghiêng rõ với trục cổ lệch nhẹ. Chú ý tư thế ngồi.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Đầu nhô/nghiêng với trục cổ lệch. Khuyến nghị kiểm soát tư thế và tập luyện.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Đầu nhô/nghiêng và lệch trục cổ rõ rệt. Khuyến nghị đánh giá chuyên môn.",
  "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang":
      "Sắp xếp cột sống ngực nhìn chung bình thường, không có bất thường cấu trúc rõ rệt",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Lệch trục ngực nhẹ. Khuyến nghị tăng cường kiểm soát tư thế.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Lệch trục ngực ảnh hưởng độ ổn định. Khuyến nghị tập luyện chuyên biệt.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Lệch trục ngực rõ và mất đối xứng. Khuyến nghị điều chỉnh chuyên môn.",
  "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "Sắp xếp cột sống thắt lưng bình thường, tư thế cân bằng, không có bất thường cấu trúc rõ rệt",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Lệch trục thắt lưng nhẹ, tư thế cân bằng. Khuyến nghị tập ổn định cơ lõi.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Lệch trục thắt lưng ảnh hưởng độ ổn định. Khuyến nghị tập điều chỉnh.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Lệch trục thắt lưng rõ rệt. Khuyến nghị kế hoạch cải thiện chuyên môn.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Căng cơ: nâng vai, SCM, thang trên. Yếu: gập cổ sâu. Khuyến nghị ổn định và thư giãn.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Căng cơ: SCM trái và bậc thang sau. Yếu: SCM phải. Khuyến nghị cân bằng hai bên và thư giãn.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Căng cơ: SCM phải. Yếu: SCM trái và bậc thang sau. Khuyến nghị ổn định đối xứng và thư giãn.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Căng cơ: thang trên trái. Yếu: thang giữa/dưới. Khuyến nghị tập (giữa/dưới) và thư giãn.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Căng cơ: xoay trong và khép háng. Yếu: mông nhỡ. Khuyến nghị tập cơ mông và giãn cơ.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Căng cơ: mông nhỡ và hình lê. Yếu: cơ khép, xoay trong, LCL. Khuyến nghị ổn định chân và thư giãn mông.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Căng cơ: mông nhỡ và hình lê. Yếu một bên: cơ khép, xoay trong, LCL. Khuyến nghị tập hai bên.",
  "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Khuyến nghị duy trì tập luyện cân bằng, tránh sử dụng quá mức một bên.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Căng cơ: gân kheo trái và cơ khoeo. Yếu: tứ đầu và cơ dép. Khuyến nghị tập tứ đầu/cơ dép và giãn cơ.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Căng cơ: tứ đầu trái. Yếu: mông lớn và gân kheo. Khuyến nghị tập mông/chuỗi sau và giãn cơ.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Căng cơ: gân kheo phải và cơ khoeo. Yếu: tứ đầu và cơ dép. Khuyến nghị tập tứ đầu/cơ dép và giãn cơ.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Căng cơ: tứ đầu phải. Yếu: mông lớn và gân kheo. Khuyến nghị tập mông/chuỗi sau và giãn cơ.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Lệch cột sống nhẹ. Chú ý tư thế và tập cơ lõi.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Lệch cột sống vừa. Khuyến nghị tập luyện có hướng dẫn chuyên môn.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu":"Bất thường nghiêm trọng cấu trúc cột sống, khuyến nghị đi khám để được đánh giá đa học phái.",
  "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Đánh giá cơ bắp bình thường, vui lòng duy trì thói quen sống tốt",
  "teng-tong-qian-zai-feng-xian-ping-gu": "Đánh giá rủi ro đau tiềm ẩn",
  "jing-bu": "Vùng cổ",
  "bei-bu": "Vùng lưng",
  "yao-bu": "Vùng thắt lưng",
  "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Điểm bất thường cấu trúc tổng thể vùng cổ",
  "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Điểm bất thường cấu trúc tổng thể vùng lưng",
  "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Điểm bất thường cấu trúc tổng thể vùng thắt lưng",
  "di-feng-xian": "Nguy cơ thấp",
  "zhong-feng-xian": "Nguy cơ trung bình",
  "ji-zhu-jie-gou-ke-shi-hua": "Trực quan hóa cấu trúc cột sống",
  "tuo-dong-xuan-zhuan-shi-tu": "Kéo để xoay khung hình",
  "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun": "Mô hình này chỉ dùng tham khảo, đánh giá thực tế dựa trên kiểm tra chuyên nghiệp",
  "bei-mian": "Mặt sau",
  "zheng-shi-tu": "Nhìn từ phía trước",
  "you-shi-tu": "Nhìn từ bên phải",
  "hou-shi-tu": "Nhìn từ phía sau",
  "zuo-shi-tu": "Nhìn từ bên trái",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Căng cơ: thang trên phải. Yếu: thang giữa/dưới. Khuyến nghị tập (giữa/dưới) và thư giãn.",
  "tun-xing": "Dáng mông",
  "dui-bi": "So sánh",
  "fang-xing-tun": "Mông vuông",
  "li-xing-tun": "Mông hình lê",
  "dao-san-jiao-xing-tun": "Mông hình tam giác ngược",
  "yuan-xing-tun": "Mông tròn",
  "jiao-li-xiang": "Khá lý tưởng",
  "mi-tao-tun": "Mông đào",
  "ben-ci": "Lần này",
  "li-shi": "Lịch sử",
  "ben-ci-li-shi": "Lần này, lịch sử",
  "tun-wei": "Vòng mông",
  "tun-xing-shuo-ming": "Giải thích dáng mông",
  "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai": "Dáng mông là đường cong và hình dạng được tạo thành giữa phần sau cơ thể và phần đùi. Đánh giá dáng mông có thể giúp mọi người quản lý hình ảnh và sức khỏe tốt hơn",
  "wo-zhi-dao-le": "Đã hiểu",
  "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du":
      "Mông vuông: cảm quan trực quan là phần trên và dưới rộng như nhau, hai bên mông khá thẳng, ít cong.",
  "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing":
      "Mông tròn: trông giống hình tròn, mỡ mông phân bố đều, đầy đặn tròn trịa, là dáng mông rất lý tưởng.",
  "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man":
      "Mông hình lê: phần trên hẹp phần dưới rộng, phần dưới mông có nhiều cơ và mỡ hơn, đường nét chưa đầy đặn.",
  "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing":
      "Mông tam giác ngược: phần trên rộng phần dưới hẹp, giống tam giác ngược.",
  "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing":
      "Mông đào: hình dạng giống quả đào, phần dưới mông đầy đặn, eo thon, là dáng mông rất lý tưởng.",
  "zan-wu-mo-xing": "Chưa có mô hình",
  "ce-liang": "Đo lường",
  "ben-ci-ce-liang": "Lần đo này",
  "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang":
      "Lần đo này chưa ghép mô hình thành công, vui lòng đo lại trên thiết bị",
  "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi":
      "Không có mô hình cho ngày này, vui lòng chọn ngày so sánh khác",
  "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "Lần đo đầu tiên, chưa có dữ liệu lịch sử",
  "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia":
      "Tải mô hình thất bại, vui lòng làm mới trang và thử lại",
  "jing-zhui-7": "Đốt sống cổ thứ 7 (C7)",
  "di-gu-zhong-dian": "Điểm giữa xương cùng",
  "di-gu-hou-shang-jiao": "Góc trên sau xương cùng",
  "ren-ti-zhong-xin": "Trọng tâm cơ thể",
  "spine-tips1":"Báo cáo này chỉ dùng tham khảo, không làm cơ sở chẩn đoán y tế. Khuyến nghị kết hợp ý kiến bác sĩ để đánh giá toàn diện.",
  "spine-tips2": "Hệ thống đánh giá chuyên biệt cột sống Visbody 2025",
  'tun-xing-ping-gu': 'Đánh giá dáng mông',
  "yi-xia-shi-nin-de-tun-xing-lei-xing": "Dưới đây là loại dáng mông của bạn",
  "qi-ta-tun-xing": "Dáng mông khác",
  "ji-zhu-ping-gu": "Đánh giá cột sống",
  "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu":
      "Đánh giá rủi ro chuyên biệt cột sống thanh thiếu niên",
  "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "Chỉ số phát triển cột sống thanh thiếu niên",
  "xue-xi-zi-shi-fu-he-zhi-shu": "Chỉ số tải tư thế khi học tập",
  "gu-ge-ping-heng-zhi-shu": "Chỉ số cân bằng khung xương",
  "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "Chỉ số cảnh báo đau giai đoạn tăng trưởng",
  "ji-zhu-ce-wan-feng-xian-ping-fen": "Điểm rủi ro cong vẹo cột sống",
  "qia-yao-ji-shu-ji-ji": "Cơ chậu hông / cơ duỗi sống",
  "xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Căng phần dưới, cơ ngang bụng yếu",
  "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti":
      "Phát triển cột sống bình thường, không có vấn đề cấu trúc rõ rệt",
  "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan":
      "Có nguy cơ phát triển nhẹ, nên cải thiện thói quen tư thế",
  "zhong-du-fa-yu-feng-xian": "Nguy cơ phát triển trung bình",
  "yan-zhong-ying-xiang-ji-zhu-fa-yu": "Ảnh hưởng nghiêm trọng đến phát triển cột sống",
  "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi":
      "Tư thế học tập tốt, có thể duy trì trong thời gian dài",
  "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi":
      "Tư thế cần cải thiện, nên nghỉ mỗi 45 phút",
  "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen":
      "Có vấn đề tư thế rõ rệt, cần kéo giãn định kỳ",
  "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu":
      "Tư thế học tập rất kém, có thể ảnh hưởng hiệu quả học tập và sự phát triển",
  "gu-ge-fa-yu-dui-cheng-zi-shi-wen-dinh": "Phát triển xương đối xứng, tư thế ổn định",
  "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce": "Có mất cân đối nhẹ, nên theo dõi",
  "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi": "Phát triển không đều, cần biện pháp điều chỉnh",
  "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang":
      "Phát triển xương mất cân đối nghiêm trọng, ảnh hưởng tăng trưởng",
  "zi-shi-liang-hao-teng-tong-feng-xian-di": "Tư thế tốt, nguy cơ đau thấp",
  "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li":
      "Nguy cơ đau nhẹ, nên quản lý tư thế",
  "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao":
      "Nguy cơ đau trung bình, cần hướng dẫn chuyên môn",
  "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan":"Nguy cơ đau đớn cao, có thể đã có cảm giác khó chịu",
  "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan":"Nguy cơ thấp, vui lòng duy trì thói quen tư thế tốt",
  "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu":"Nguy cơ trung bình, có thể cần quan sát hoặc can thiệp thêm",
  "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu":"Nguy cơ cao, cần đi khám kịp thời để được đánh giá y tế chuyên nghiệp",
  "you-liang":"Xuất sắc",
  "zhu-yi":"Chú ý",
  "gan-yu":"Can thiệp",
  "jing-shi":"Cảnh báo",
  "di-fu-he":"Tải nặng thấp",
  "zhong-fu-he":"Tải nặng trung bình",
  "gao-fu-he":"Tải nặng cao",
  "guo-zai":"Quá tải",
  "ping-heng-xing":"Cân bằng",
  "qing-du-bu-ping-heng":"Mất cân bằng nhẹ",
  "zhong-du-bu-ping-heng":"Mất cân bằng trung bình",
  "yan-zhong-bu-ping-heng":"Mất cân bằng nghiêm trọng",
  "an-quan":"An toàn",
  "wei-xian":"Nguy hiểm",
  "neckReport": {
  "title": "Chức năng cổ",
  "conclusion": "Đánh giá chức năng cổ",
  "loading": "Đang tạo báo cáo. Vui lòng chờ.",
  "failed": "Báo cáo tổng hợp không thành công",
  "analysis": "Phân tích",
  "suggestion": "đề xuất",
  "suggestionText": "Tìm chuyên gia để làm xét nghiệm và điều trị sâu hơn về nguyên nhân cụ thể"
}
}
